// extracted by mini-css-extract-plugin
module.exports = {"descriptionBox":"DescriptionBox_descriptionBox__2ruBP","h1":"DescriptionBox_h1__lss_M"};